import React from 'react';
import styles from './FoundCustodianSection.module.scss';
import { CustodianCard } from 'components/ui';
import { FoundCustodian } from 'types';
import { PreloaderWrapper } from 'components/containers';
import { SelectedCustodian } from 'components/ui/MapSearch/MapSearch';
import clsx from 'clsx';

export type FoundCustodianSectionProps = {
  foundCustodians: FoundCustodian[];
  isPreloader: boolean;
  selected: SelectedCustodian;
  handleSelect: (data: SelectedCustodian & { selectedLocation: string | null }) => void;
  searchData?: any;
  onScroll?: () => void;
  isDetailsLoading: boolean;
  isFormRequest: boolean
};

export const FoundCustodianSection: React.FC<FoundCustodianSectionProps> = ({
  foundCustodians,
  isPreloader,
  selected,
  handleSelect,
  onScroll,
  searchData,
  isDetailsLoading,
  isFormRequest
}) => {
  if (isPreloader) return <PreloaderWrapper />;
  return (
    <div className={'col-sm-10 custodian_serach_wrapper ' +clsx(styles['root'])} onScroll={onScroll} id='custodianScroolContainer'>
      {foundCustodians.length ? foundCustodians?.map(item => {
        const selectedCustodian: SelectedCustodian = {
          id: item.id,
          name: item.name,
          latitude: item.latitude,
          longitude: item.longitude,
          forms: item.patient_form_templates || []
        };

        return (
          <CustodianCard
            key={item.id}
            {...item}
            selectedLocation={selected?.selectedLocation}
            isChecked={selected?.id === item.id}
            onClick={(selectedLocation: string | null, selectedSiteLocationName: string | null) => handleSelect({ ...selectedCustodian, selectedLocation, selectedSiteLocationName })}
            favorite={item.is_favorite}
            isDetailsLoading={isDetailsLoading}
            isFormRequest={isFormRequest}
          />
        );
      }) : <div>No custodian found!</div>}
      {searchData.searching && <PreloaderWrapper />}
    </div>
  );
};
